
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gSUUF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $21fc85475dfdc5df$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $21fc85475dfdc5df$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "Team \u2022 50+ membri",
    'fabric.elements.mentions.team.member.50plus.including.you': "Team \u2022 50+ membri, te compreso",
    'fabric.elements.mentions.team.member.count': "{0, plural, one {Team \u2022 1 membro} other {Team \u2022 {0} membri}}",
    'fabric.elements.mentions.team.member.count.including.you': "{0, plural, one {Team \u2022 1 membro, te compreso} other {Team \u2022 {0} membri, te compreso}}",
    'fabric.elements.mentions.xproduct.mention.description': "Necessita dell'accesso a Confluence",
    'fabric.mention.error.defaultAction': 'Riprova tra qualche secondo',
    'fabric.mention.error.defaultHeadline': "Si \xe8 verificato un errore",
    'fabric.mention.error.differentText': 'Prova a inserire un testo diverso',
    'fabric.mention.error.loginAgain': 'Prova a uscire e ad accedere di nuovo',
    'fabric.mention.noAccess.label': 'Nessun accesso',
    'fabric.mention.noAccess.warning': "A {name} non verr\xe0 inviata una notifica poich\xe9 non ha accesso",
    'fabric.mention.unknow.user.error': 'Utente {userId} sconosciuto'
};

});


//# sourceMappingURL=it.fbe42f1a.js.map
